const statsOrder = [
  'won_matches',
  'tied_matches',
  'lost_matches',
  'total_shots',
  'total_fouls_conceded',
  'total_passes',
  'possession_percentage',
  'corners_won',
  'total_successful_passes_excl_crosses_corners',
  'recoveries',
  'total_losses_of_possession',
  'successful_corners_into_box',
  'total_shots_conceded',
  'yellow_cards',
  'red_card_2nd_yellow',
  'total_red_cards',
];

export const getOrderedData = data => {
  const orderedData = [...data];
  orderedData.sort((a, b) => {
    const aIndex = statsOrder.indexOf(a.statName);
    const aOrder = aIndex >= 0 ? aIndex : statsOrder.length;
    const bIndex = statsOrder.indexOf(b.statName);
    const bOrder = bIndex >= 0 ? bIndex : statsOrder.length;

    return aOrder - bOrder;
  });

  return orderedData;
};
